import APIService from '../../../../Services/APIService';
import { Apis } from '../../../../Services/app.constants';

const requireId = (value, label) => {
  if (!value) throw new Error(`${label} is required`);
  return encodeURIComponent(String(value));
};

export const schedulerService = {
  listSchedulers(formId) {
    return APIService.get(`${Apis.leadSchedular}?form_id=${requireId(formId, 'Form ID')}`);
  },

  createScheduler(payload) {
    return APIService.post(Apis.leadSchedular, payload);
  },

  updateScheduler(payload) {
    return APIService.put(
      `${Apis.leadSchedular}?scheduler_id=${requireId(
        payload?.scheduler_id,
        'Scheduler ID'
      )}`,
      payload
    );
  },

  deleteScheduler(schedulerId) {
    return APIService.remove(
      `${Apis.leadSchedular}?scheduler_id=${requireId(schedulerId, 'Scheduler ID')}`
    );
  },
};

export default schedulerService;
